import React, { useState, useRef } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { formatNumber } from "../../../utils/DefaultFunction";

import { PRIMARY_BG } from '../../../theme/brand';
const TemplateTypeUsageGrowth = ({ growthData }) => {
  const [hiddenSeries, setHiddenSeries] = useState({});
  const chartRef = useRef(null);

  if (!growthData) return <div>No data</div>;

  const { months, series } = growthData;

  const colors = {
    authentication: "#f97316",
    transaction: "#10b981",
    informational: PRIMARY_BG,
    marketing: "#8b5cf6"
  };

  // Convert series data to Highcharts format
  const seriesData = Object.keys(series).map((key) => ({
    name: key.charAt(0).toUpperCase() + key.slice(1),
    data: series[key],
    color: colors[key],
    visible: !hiddenSeries[key],
    marker: {
      enabled: true,
      radius: 5,
      lineWidth: 2,
      lineColor: "#ffffff",
      fillColor: colors[key]
    },
    states: {
      hover: {
        marker: {
          radius: 7,
          lineWidth: 2,
          lineColor: "#ffffff"
        }
      }
    }
  }));

  const options = {
    chart: {
      type: "area",
      height: 600,
      backgroundColor: "transparent",
      marginLeft: 60,
      marginRight: 20
    },
    title: {
      text: null
    },
    xAxis: {
      categories: months,
      crosshair: true,
      labels: {
        style: {
          color: "#666"
        }
      },
      tickmarkPlacement: 'on',
      startOnTick: true,
      endOnTick: true
    },
    yAxis: {
      title: {
        text: null
      },
      labels: {
        style: {
          color: "#666"
        }
      },
      gridLineColor: "#e5e5e5"
    },
    tooltip: {
      shared: true,
      backgroundColor: "rgba(255, 255, 255, 0.95)",
      borderColor: "#ccc",
      borderRadius: 8,
      shadow: true,
      useHTML: true,
      formatter: function () {
        let tooltip = `<b>${this.x}</b><br/>`;
        this.points.forEach((point) => {
          tooltip += `<span style="color:${point.color}">●</span> ${point.series.name}: <b>${formatNumber(point.y)}</b><br/>`;
        });
        return tooltip;
      }
    },
    plotOptions: {
      area: {
        stacking: "normal",
        lineWidth: 2,
        marker: {
          enabled: true,
          symbol: "circle"
        },
        fillOpacity: 0.6,
        states: {
          hover: {
            lineWidth: 2
          }
        }
      },
      series: {
        events: {
          legendItemClick: function () {
            const seriesName = this.name.toLowerCase();
            setHiddenSeries((prev) => ({
              ...prev,
              [seriesName]: !prev[seriesName]
            }));
            return true; // Allow default toggle behavior
          }
        }
      }
    },
    legend: {
      align: "center",
      verticalAlign: "bottom",
      layout: "horizontal",
      itemStyle: {
        color: "#333",
        fontWeight: "normal",
        cursor: "pointer"
      },
      itemHoverStyle: {
        color: "#000"
      },
      symbolRadius: 10,
      symbolHeight: 12,
      symbolWidth: 12
    },
    series: seriesData,
    credits: {
      enabled: false
    }
  };

  return (
    <div style={{ width: "100%", height: "600px" }}>
      <HighchartsReact
        highcharts={Highcharts}
        options={options}
        ref={chartRef}
      />
    </div>
  );
};

export default TemplateTypeUsageGrowth;